import {
    GET_TRANSACTION_SOURCE_DEF_SUCCESS,
    TRANSACTION_SOURCE_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const transactionSourceDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_TRANSACTION_SOURCE_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case TRANSACTION_SOURCE_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default transactionSourceDef